import { render, staticRenderFns } from "./button-type-editor.vue?vue&type=template&id=7f68d368&scoped=true&"
import script from "./button-type-editor.vue?vue&type=script&lang=js&"
export * from "./button-type-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f68d368",
  null
  
)

export default component.exports